import { render, staticRenderFns } from "./group-message.vue?vue&type=template&id=5359d89a&"
import script from "./group-message.vue?vue&type=script&lang=js&"
export * from "./group-message.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports